export const NOTIFICATION_DASHBOARD_CHART_TYPES = new Map([
  [
    1,
    {
      title: 'EPROMS',
      alertTitle: 'Alerts (EPROMS)',
      value: 1
    }
  ],
  [
    2,
    {
      title: 'Measurements',
      alertTitle: 'Alerts (Measurements)',
      value: 2
    }
  ],
  [
    3,
    {
      title: 'Medications',
      alertTitle: 'Alerts (Medications)',
      value: 3
    }
  ]
])
